jQuery(function() {
  
  $("#canadaActive").on('click',function() {
	$(".canada").show("slow");
	$(".usa,.mexico,.peru,.chile,.brazil,.europe,.asia,.australia,.panama,.colombia,.israel").hide("slow");
  });

  $("#usaActive").on('click',function() {
      $(".usa").show("slow");
      $(".canada,.mexico,.peru,.chile,.brazil,.europe,.asia,.australia,.panama,.colombia,.israel").hide("slow");
  });

  $("#mexicoActive").on('click',function() {
      $(".mexico").show("slow");
      $(".usa,.canada,.peru,.chile,.brazil,.europe,.asia,.australia,.panama,.colombia,.israel").hide("slow");
  });

  $("#panamaActive").on('click',function() {
      $(".panama").show("slow");
      $(".usa,.mexico,.canada,.peru,.chile,.brazil,.europe,.asia,.australia,.colombia,.israel").hide("slow");
  });

  $("#colombiaActive").on('click',function() {
      $(".colombia").show("slow");
      $(".usa,.mexico,.canada,.peru,.chile,.brazil,.europe,.asia,.australia,.panama,.israel").hide("slow");
  });

  $("#peruActive").on('click',function() {
      $(".peru").show("slow");
      $(".usa,.mexico,.canada,.chile,.brazil,.europe,.asia,.australia,.panama,.colombia,.israel").hide("slow");
  });

  $("#chileActive").on('click',function() {
      $(".chile").show("slow");
      $(".usa,.mexico,.canada,.peru,.brazil,.europe,.asia,.australia,.panama,.colombia,.israel").hide("slow");
  });

  $("#brazilActive").on('click',function() {
      $(".brazil").show("slow");
      $(".usa,.mexico,.canada,.peru,.chile,.europe,.asia,.australia,.panama,.colombia,.israel").hide("slow");
  });

  $("#europeActive").on('click',function() {
      $(".europe").show("slow");
      $(".usa,.mexico,.canada,.peru,.chile,.brazil,.asia,.australia,.panama,.colombia,.israel").hide("slow");
  });

  $("#israelActive").on('click',function() {
      $(".israel").show("slow");
      $(".usa,.mexico,.canada,.peru,.chile,.europe,.brazil,.asia,.australia,.panama,.colombia").hide("slow");
  });

  $("#asiaActive").on('click',function() {
      $(".asia").show("slow");
      $(".usa,.mexico,.canada,.peru,.chile,.brazil,.europe,.australia,.panama,.colombia,.israel").hide("slow");
  });

  $("#australiaActive").on('click',function() {
      $(".australia").show("slow");
      $(".usa,.mexico,.canada,.peru,.chile,.brazil,.europe,.asia,.panama,.colombia,.israel").hide("slow");
  });
  
});